import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QueryKeys } from '../keys';
import { request } from '../request';
import { userQueryOptions } from './useUser';

export const useUnlinkCashaca = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return request('/integrations/accountancy-software/unlink-cashaca', { method: 'POST' });
    },
    onSuccess: () => {
      queryClient.setQueryData(userQueryOptions.queryKey, (user) => {
        if (!user) return;

        return { ...user, integrations: { ...user.integrations, cashaca: false } };
      });
      queryClient.invalidateQueries({ queryKey: QueryKeys.user });
    },
  });
};
